<template>
  <section id="accordions">
    <div class="demo">
      <section id="accordion-sm" class="accordion-line" role="tablist" aria-multiselectable="true">
        <article>
          <div class="accordion-header" role="tab" id="headingTwo">
            <h5 class="mb-0">
              <a
                data-toggle="collapse"
                data-parent="#accordion-sm"
                href="#collapse-a"
                aria-expanded="true"
                aria-controls="collapseOne"
              >Accordion Item #1</a>
            </h5>
          </div>
          <div
            id="collapse-a"
            class="accordion-body collapse show"
            role="tabpanel"
            aria-labelledby="headingOne"
          >
            <table class="table table-borderless table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First</th>
                  <th scope="col">Last</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                </tr>
                <tr>
                  <th scope="row">3</th>
                  <td colspan="2">Larry the Bird</td>
                  <td>@twitter</td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                </tr>
                <tr>
                  <th scope="row">3</th>
                  <td colspan="2">Larry the Bird</td>
                  <td>@twitter</td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article>
          <div class="accordion-header" role="tab" id="headingTwo">
            <h5 class="mb-0">
              <a
                class="collapsed"
                data-toggle="collapse"
                data-parent="#accordion-sm"
                href="#collapse-b"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >Accordion Item #2</a>
            </h5>
          </div>
          <div
            id="collapse-b"
            class="accordion-body collapse"
            role="tabpanel"
            aria-labelledby="headingTwo"
          >Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch.</div>
        </article>
        <article>
          <div class="accordion-header" role="tab" id="headingThree">
            <h5 class="mb-0">
              <a
                class="collapsed"
                data-toggle="collapse"
                data-parent="#accordion-sm"
                href="#collapse-c"
                aria-expanded="false"
                aria-controls="collapseThree"
              >Accordion Item #3</a>
            </h5>
          </div>
          <div
            id="collapse-c"
            class="accordion-body collapse"
            role="tabpanel"
            aria-labelledby="headingThree"
          >Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</div>
        </article>
      </section>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import BSN from "bootstrap.native/dist/bootstrap-native-v4";
import mdfile from "@/docs/components/accordions.md";
export default {
  name: "accordions",
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.components.accordions.name);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.components.accordions.description
    );
  },
  mounted: function() {
    const accordions = document.querySelectorAll(
      '[data-parent="#accordion-sm"]'
    );
    accordions.forEach(accordion => {
      new BSN.Collapse(accordion);
    });
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
